/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists, mapValues} from '../runtime'
import {MessageDTO, MessageDTOFromJSON, MessageDTOFromJSONTyped, MessageDTOToJSON} from './'

/**
 *
 * @export
 * @interface SendRequestDTO
 */
export interface SendRequestDTO {
    /**
     *
     * @type {string}
     * @memberof SendRequestDTO
     */
    insuranceType: SendRequestDTOInsuranceTypeEnum
    /**
     *
     * @type {MessageDTO}
     * @memberof SendRequestDTO
     */
    message: MessageDTO
}

export function SendRequestDTOFromJSON(json: any): SendRequestDTO {
    return SendRequestDTOFromJSONTyped(json, false)
}

export function SendRequestDTOFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): SendRequestDTO {
    if (json === undefined || json === null) {
        return json
    }
    return {
        insuranceType: json['insuranceType'],
        message: MessageDTOFromJSON(json['message']),
    }
}

export function SendRequestDTOToJSON(value?: SendRequestDTO | null): any {
    if (value === undefined) {
        return undefined
    }
    if (value === null) {
        return null
    }
    return {
        insuranceType: value.insuranceType,
        message: MessageDTOToJSON(value.message),
    }
}

/**
 * @export
 * @enum {string}
 */
export enum SendRequestDTOInsuranceTypeEnum {
    Vzr = 'vzr',
    Accident = 'accident',
    Osago = 'osago',
    Dms = 'dms',
}
